import * as angular from "angular";
import { Constants as constants } from "../../constants";
import { ClientRepo as clientRepo } from "./client.repo";
import { clients } from "./clients";
import { clientDetails } from "./clients.details/clientdetails";
import { newPortfolioModal } from "./clients.details/newportfolio.modal";
import { PortfolioRepo } from "../portfolio/portfolio.repo";
import { fixedHeaderModule } from "../common/fixed-header.directive";
import { TradingRepo } from "../trading/trading.repo";
import { editTradeRestrictionModal } from "./clients.details/editTradeRestriction.modal";
import { portfolioTransfer } from "./clients.details/portfolioTransfer.modal";

export const clientsModule = "clients";

angular
  .module(clientsModule, [
    "ui.router",
    "dataGrid",
    "pagination",
    "angular-loading-bar",
    "angularModalService",
    fixedHeaderModule,
  ])
  .constant("config", constants.Default)
  .service("clientRepo", clientRepo)
  .service("portfolioRepo", PortfolioRepo)
  .service("tradingRepo", TradingRepo)
  .component("newPortfolioModal", newPortfolioModal)
  .component("clientDetails", clientDetails)
  .component("clients", clients)
  .component("editTradeRestrictionModal", editTradeRestrictionModal)
  .component("portfolioTransfer", portfolioTransfer);



// WEBPACK FOOTER //
// ./src/app/clients/clients.index.ts